<div fxLayout="row" *ngFor="let creditCard of creditCards">
  <img style="height: 17px;" src="assets/img/brands/{{creditCard.card.brand.toLowerCase()}}.png">
  {{creditCard.installments+'x'}} </div>
